// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2844224a","239":"a82e9d15","455":"68023d1e"}[chunkId] + ".chunk.js";
};